var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Rect, Path } from "react-native-svg";
function SvgStrideSelected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#E1087E"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E1087E",
    rx: 15.5
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M9.825 17l1.875 1.875c.183.2.28.438.288.712a.93.93 0 01-.288.713c-.2.2-.433.3-.7.3a.96.96 0 01-.7-.3l-3.6-3.6a.877.877 0 01-.213-.325A1.107 1.107 0 016.425 16c0-.133.02-.258.063-.375A.877.877 0 016.7 15.3l3.6-3.6c.2-.2.433-.3.7-.3.267 0 .5.1.7.3.2.2.3.438.3.713 0 .274-.1.512-.3.712L9.825 15h12.35L20.3 13.125a1.07 1.07 0 01-.288-.713.93.93 0 01.288-.712c.2-.2.433-.3.7-.3.267 0 .5.1.7.3l3.6 3.6c.1.1.17.208.212.325.042.117.063.242.063.375s-.02.258-.063.375a.877.877 0 01-.212.325l-3.6 3.6c-.2.2-.433.3-.7.3a.96.96 0 01-.7-.3c-.2-.2-.3-.438-.3-.713 0-.274.1-.512.3-.712L22.175 17H9.825z"
  }))));
}
export default SvgStrideSelected;